import { connect } from "react-redux";
import fb from "../../../assets/images/svg/ic_fb_12x12.svg";
import { setPage } from "../../../store/action/pageAction";
import ImagePageFb from "../components/Images/ImagePageFb";

const ListPage = (props) => {
   const { pages, setPage } = props;

   return (
      <ul className="app-messaging-first--list-page app-scrollbar">
         {pages.map((item, index) => {
            return (
               <li className="app-messaging-first--page-item" key={index} onClick={() => setPage(item)}>
                  <div className="app-messaging-first--page-item--image">
                     <span content={item.name} className="app-avatar app-messaging-first--page-item--icon app-avatar-lg app-avatar-circle app-avatar-image" >
                        <ImagePageFb src={item.page_avatar} />
                     </span>
                     <div className="app-messaging-first--channelIcon">
                        <div className="app-messaging-first--iconWrapper">
                           <img className="app-messaging-first--iconChannel" src={fb} alt="Facebook" />
                        </div>
                     </div>
                  </div>
                  <div className="app-messaging-first--page-item--info">
                     <div className="app-messaging-first--page-item--info--name ">
                        <div className="app-messaging-first--content-1-line" title={item.name}>
                           {item.name}
                        </div>
                     </div>
                     <div className="app-messaging-first--page-id">
                        ID: {item.social_id}
                     </div>
                  </div>
               </li>
            )
         })}

      </ul>
   )
}

const mapStateToProps = (state) => {
   const { pages } = state;

   return {
      pages
   };
};

export default connect(mapStateToProps, {
   setPage
})(ListPage);